import { render, staticRenderFns } from "./reviewAwaiting.vue?vue&type=template&id=52d6c96c&scoped=true&"
import script from "./reviewAwaiting.vue?vue&type=script&lang=js&"
export * from "./reviewAwaiting.vue?vue&type=script&lang=js&"
import style0 from "./reviewAwaiting.vue?vue&type=style&index=0&id=52d6c96c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6c96c",
  null
  
)

export default component.exports